import React from 'react'
import { Outlet } from 'react-router-dom'

const RestrictLayout: React.FC = () => {
  return <Outlet />
}

export default RestrictLayout
